/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as JoinCodeRouteImport } from './routes/join.$code'
import { Route as AuthedNewRouteImport } from './routes/_authed/new'
import { Route as AuthedWorkspaceIdLayoutRouteImport } from './routes/_authed/$workspaceId/_layout'
import { Route as AuthedWorkspaceIdLayoutTeamRouteImport } from './routes/_authed/$workspaceId/_layout/team'
import { Route as AuthedWorkspaceIdLayoutSettingsRouteImport } from './routes/_authed/$workspaceId/_layout/settings'
import { Route as AuthedWorkspaceIdLayoutSearchRouteImport } from './routes/_authed/$workspaceId/_layout/search'
import { Route as AuthedWorkspaceIdLayoutClientsRouteImport } from './routes/_authed/$workspaceId/_layout/clients'
import { Route as AuthedWorkspaceIdLayoutBoardRouteImport } from './routes/_authed/$workspaceId/_layout/board'
import { Route as AuthedWorkspaceIdLayoutAnalyticsRouteImport } from './routes/_authed/$workspaceId/_layout/analytics'
import { Route as AuthedWorkspaceIdLayouthomeIndexRouteImport } from './routes/_authed/$workspaceId/_layout/(home)/index'
import { Route as AuthedWorkspaceIdLayoutestimateEstimatesRouteImport } from './routes/_authed/$workspaceId/_layout/(estimate)/estimates'
import { Route as AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutRouteImport } from './routes/_authed/$workspaceId/_layout/(order)/order/$orderId/_layout'
import { Route as AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutRouteImport } from './routes/_authed/$workspaceId/_layout/(estimate)/estimate/$estimateId/_layout'
import { Route as AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutIndexRouteImport } from './routes/_authed/$workspaceId/_layout/(order)/order/$orderId/_layout/index'
import { Route as AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutIndexRouteImport } from './routes/_authed/$workspaceId/_layout/(estimate)/estimate/$estimateId/_layout/index'
import { Route as AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutChatRouteImport } from './routes/_authed/$workspaceId/_layout/(order)/order/$orderId/_layout/chat'
import { Route as AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutChatRouteImport } from './routes/_authed/$workspaceId/_layout/(estimate)/estimate/$estimateId/_layout/chat'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const JoinCodeRoute = JoinCodeRouteImport.update({
  id: '/join/$code',
  path: '/join/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedNewRoute = AuthedNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedWorkspaceIdLayoutRoute = AuthedWorkspaceIdLayoutRouteImport.update({
  id: '/$workspaceId/_layout',
  path: '/$workspaceId',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedWorkspaceIdLayoutTeamRoute =
  AuthedWorkspaceIdLayoutTeamRouteImport.update({
    id: '/team',
    path: '/team',
    getParentRoute: () => AuthedWorkspaceIdLayoutRoute,
  } as any)
const AuthedWorkspaceIdLayoutSettingsRoute =
  AuthedWorkspaceIdLayoutSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthedWorkspaceIdLayoutRoute,
  } as any)
const AuthedWorkspaceIdLayoutSearchRoute =
  AuthedWorkspaceIdLayoutSearchRouteImport.update({
    id: '/search',
    path: '/search',
    getParentRoute: () => AuthedWorkspaceIdLayoutRoute,
  } as any)
const AuthedWorkspaceIdLayoutClientsRoute =
  AuthedWorkspaceIdLayoutClientsRouteImport.update({
    id: '/clients',
    path: '/clients',
    getParentRoute: () => AuthedWorkspaceIdLayoutRoute,
  } as any)
const AuthedWorkspaceIdLayoutBoardRoute =
  AuthedWorkspaceIdLayoutBoardRouteImport.update({
    id: '/board',
    path: '/board',
    getParentRoute: () => AuthedWorkspaceIdLayoutRoute,
  } as any)
const AuthedWorkspaceIdLayoutAnalyticsRoute =
  AuthedWorkspaceIdLayoutAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => AuthedWorkspaceIdLayoutRoute,
  } as any)
const AuthedWorkspaceIdLayouthomeIndexRoute =
  AuthedWorkspaceIdLayouthomeIndexRouteImport.update({
    id: '/(home)/',
    path: '/',
    getParentRoute: () => AuthedWorkspaceIdLayoutRoute,
  } as any)
const AuthedWorkspaceIdLayoutestimateEstimatesRoute =
  AuthedWorkspaceIdLayoutestimateEstimatesRouteImport.update({
    id: '/(estimate)/estimates',
    path: '/estimates',
    getParentRoute: () => AuthedWorkspaceIdLayoutRoute,
  } as any)
const AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutRoute =
  AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutRouteImport.update({
    id: '/(order)/order/$orderId/_layout',
    path: '/order/$orderId',
    getParentRoute: () => AuthedWorkspaceIdLayoutRoute,
  } as any)
const AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutRoute =
  AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutRouteImport.update({
    id: '/(estimate)/estimate/$estimateId/_layout',
    path: '/estimate/$estimateId',
    getParentRoute: () => AuthedWorkspaceIdLayoutRoute,
  } as any)
const AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutIndexRoute =
  AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutRoute,
  } as any)
const AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutIndexRoute =
  AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutRoute,
    } as any,
  )
const AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutChatRoute =
  AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutChatRouteImport.update({
    id: '/chat',
    path: '/chat',
    getParentRoute: () => AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutRoute,
  } as any)
const AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutChatRoute =
  AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutChatRouteImport.update(
    {
      id: '/chat',
      path: '/chat',
      getParentRoute: () =>
        AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/new': typeof AuthedNewRoute
  '/join/$code': typeof JoinCodeRoute
  '/$workspaceId': typeof AuthedWorkspaceIdLayoutRouteWithChildren
  '/$workspaceId/analytics': typeof AuthedWorkspaceIdLayoutAnalyticsRoute
  '/$workspaceId/board': typeof AuthedWorkspaceIdLayoutBoardRoute
  '/$workspaceId/clients': typeof AuthedWorkspaceIdLayoutClientsRoute
  '/$workspaceId/search': typeof AuthedWorkspaceIdLayoutSearchRoute
  '/$workspaceId/settings': typeof AuthedWorkspaceIdLayoutSettingsRoute
  '/$workspaceId/team': typeof AuthedWorkspaceIdLayoutTeamRoute
  '/$workspaceId/estimates': typeof AuthedWorkspaceIdLayoutestimateEstimatesRoute
  '/$workspaceId/': typeof AuthedWorkspaceIdLayouthomeIndexRoute
  '/$workspaceId/estimate/$estimateId': typeof AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutRouteWithChildren
  '/$workspaceId/order/$orderId': typeof AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutRouteWithChildren
  '/$workspaceId/estimate/$estimateId/chat': typeof AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutChatRoute
  '/$workspaceId/order/$orderId/chat': typeof AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutChatRoute
  '/$workspaceId/estimate/$estimateId/': typeof AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutIndexRoute
  '/$workspaceId/order/$orderId/': typeof AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutIndexRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/new': typeof AuthedNewRoute
  '/join/$code': typeof JoinCodeRoute
  '/': typeof AuthedIndexRoute
  '/$workspaceId/analytics': typeof AuthedWorkspaceIdLayoutAnalyticsRoute
  '/$workspaceId/board': typeof AuthedWorkspaceIdLayoutBoardRoute
  '/$workspaceId/clients': typeof AuthedWorkspaceIdLayoutClientsRoute
  '/$workspaceId/search': typeof AuthedWorkspaceIdLayoutSearchRoute
  '/$workspaceId/settings': typeof AuthedWorkspaceIdLayoutSettingsRoute
  '/$workspaceId/team': typeof AuthedWorkspaceIdLayoutTeamRoute
  '/$workspaceId/estimates': typeof AuthedWorkspaceIdLayoutestimateEstimatesRoute
  '/$workspaceId': typeof AuthedWorkspaceIdLayouthomeIndexRoute
  '/$workspaceId/estimate/$estimateId/chat': typeof AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutChatRoute
  '/$workspaceId/order/$orderId/chat': typeof AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutChatRoute
  '/$workspaceId/estimate/$estimateId': typeof AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutIndexRoute
  '/$workspaceId/order/$orderId': typeof AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/_authed/new': typeof AuthedNewRoute
  '/join/$code': typeof JoinCodeRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/$workspaceId/_layout': typeof AuthedWorkspaceIdLayoutRouteWithChildren
  '/_authed/$workspaceId/_layout/analytics': typeof AuthedWorkspaceIdLayoutAnalyticsRoute
  '/_authed/$workspaceId/_layout/board': typeof AuthedWorkspaceIdLayoutBoardRoute
  '/_authed/$workspaceId/_layout/clients': typeof AuthedWorkspaceIdLayoutClientsRoute
  '/_authed/$workspaceId/_layout/search': typeof AuthedWorkspaceIdLayoutSearchRoute
  '/_authed/$workspaceId/_layout/settings': typeof AuthedWorkspaceIdLayoutSettingsRoute
  '/_authed/$workspaceId/_layout/team': typeof AuthedWorkspaceIdLayoutTeamRoute
  '/_authed/$workspaceId/_layout/(estimate)/estimates': typeof AuthedWorkspaceIdLayoutestimateEstimatesRoute
  '/_authed/$workspaceId/_layout/(home)/': typeof AuthedWorkspaceIdLayouthomeIndexRoute
  '/_authed/$workspaceId/_layout/(estimate)/estimate/$estimateId/_layout': typeof AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutRouteWithChildren
  '/_authed/$workspaceId/_layout/(order)/order/$orderId/_layout': typeof AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutRouteWithChildren
  '/_authed/$workspaceId/_layout/(estimate)/estimate/$estimateId/_layout/chat': typeof AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutChatRoute
  '/_authed/$workspaceId/_layout/(order)/order/$orderId/_layout/chat': typeof AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutChatRoute
  '/_authed/$workspaceId/_layout/(estimate)/estimate/$estimateId/_layout/': typeof AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutIndexRoute
  '/_authed/$workspaceId/_layout/(order)/order/$orderId/_layout/': typeof AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/new'
    | '/join/$code'
    | '/$workspaceId'
    | '/$workspaceId/analytics'
    | '/$workspaceId/board'
    | '/$workspaceId/clients'
    | '/$workspaceId/search'
    | '/$workspaceId/settings'
    | '/$workspaceId/team'
    | '/$workspaceId/estimates'
    | '/$workspaceId/'
    | '/$workspaceId/estimate/$estimateId'
    | '/$workspaceId/order/$orderId'
    | '/$workspaceId/estimate/$estimateId/chat'
    | '/$workspaceId/order/$orderId/chat'
    | '/$workspaceId/estimate/$estimateId/'
    | '/$workspaceId/order/$orderId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/new'
    | '/join/$code'
    | '/'
    | '/$workspaceId/analytics'
    | '/$workspaceId/board'
    | '/$workspaceId/clients'
    | '/$workspaceId/search'
    | '/$workspaceId/settings'
    | '/$workspaceId/team'
    | '/$workspaceId/estimates'
    | '/$workspaceId'
    | '/$workspaceId/estimate/$estimateId/chat'
    | '/$workspaceId/order/$orderId/chat'
    | '/$workspaceId/estimate/$estimateId'
    | '/$workspaceId/order/$orderId'
  id:
    | '__root__'
    | '/_authed'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/_authed/new'
    | '/join/$code'
    | '/_authed/'
    | '/_authed/$workspaceId/_layout'
    | '/_authed/$workspaceId/_layout/analytics'
    | '/_authed/$workspaceId/_layout/board'
    | '/_authed/$workspaceId/_layout/clients'
    | '/_authed/$workspaceId/_layout/search'
    | '/_authed/$workspaceId/_layout/settings'
    | '/_authed/$workspaceId/_layout/team'
    | '/_authed/$workspaceId/_layout/(estimate)/estimates'
    | '/_authed/$workspaceId/_layout/(home)/'
    | '/_authed/$workspaceId/_layout/(estimate)/estimate/$estimateId/_layout'
    | '/_authed/$workspaceId/_layout/(order)/order/$orderId/_layout'
    | '/_authed/$workspaceId/_layout/(estimate)/estimate/$estimateId/_layout/chat'
    | '/_authed/$workspaceId/_layout/(order)/order/$orderId/_layout/chat'
    | '/_authed/$workspaceId/_layout/(estimate)/estimate/$estimateId/_layout/'
    | '/_authed/$workspaceId/_layout/(order)/order/$orderId/_layout/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRoute
  JoinCodeRoute: typeof JoinCodeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/join/$code': {
      id: '/join/$code'
      path: '/join/$code'
      fullPath: '/join/$code'
      preLoaderRoute: typeof JoinCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/new': {
      id: '/_authed/new'
      path: '/new'
      fullPath: '/new'
      preLoaderRoute: typeof AuthedNewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/$workspaceId/_layout': {
      id: '/_authed/$workspaceId/_layout'
      path: '/$workspaceId'
      fullPath: '/$workspaceId'
      preLoaderRoute: typeof AuthedWorkspaceIdLayoutRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/$workspaceId/_layout/team': {
      id: '/_authed/$workspaceId/_layout/team'
      path: '/team'
      fullPath: '/$workspaceId/team'
      preLoaderRoute: typeof AuthedWorkspaceIdLayoutTeamRouteImport
      parentRoute: typeof AuthedWorkspaceIdLayoutRoute
    }
    '/_authed/$workspaceId/_layout/settings': {
      id: '/_authed/$workspaceId/_layout/settings'
      path: '/settings'
      fullPath: '/$workspaceId/settings'
      preLoaderRoute: typeof AuthedWorkspaceIdLayoutSettingsRouteImport
      parentRoute: typeof AuthedWorkspaceIdLayoutRoute
    }
    '/_authed/$workspaceId/_layout/search': {
      id: '/_authed/$workspaceId/_layout/search'
      path: '/search'
      fullPath: '/$workspaceId/search'
      preLoaderRoute: typeof AuthedWorkspaceIdLayoutSearchRouteImport
      parentRoute: typeof AuthedWorkspaceIdLayoutRoute
    }
    '/_authed/$workspaceId/_layout/clients': {
      id: '/_authed/$workspaceId/_layout/clients'
      path: '/clients'
      fullPath: '/$workspaceId/clients'
      preLoaderRoute: typeof AuthedWorkspaceIdLayoutClientsRouteImport
      parentRoute: typeof AuthedWorkspaceIdLayoutRoute
    }
    '/_authed/$workspaceId/_layout/board': {
      id: '/_authed/$workspaceId/_layout/board'
      path: '/board'
      fullPath: '/$workspaceId/board'
      preLoaderRoute: typeof AuthedWorkspaceIdLayoutBoardRouteImport
      parentRoute: typeof AuthedWorkspaceIdLayoutRoute
    }
    '/_authed/$workspaceId/_layout/analytics': {
      id: '/_authed/$workspaceId/_layout/analytics'
      path: '/analytics'
      fullPath: '/$workspaceId/analytics'
      preLoaderRoute: typeof AuthedWorkspaceIdLayoutAnalyticsRouteImport
      parentRoute: typeof AuthedWorkspaceIdLayoutRoute
    }
    '/_authed/$workspaceId/_layout/(home)/': {
      id: '/_authed/$workspaceId/_layout/(home)/'
      path: '/'
      fullPath: '/$workspaceId/'
      preLoaderRoute: typeof AuthedWorkspaceIdLayouthomeIndexRouteImport
      parentRoute: typeof AuthedWorkspaceIdLayoutRoute
    }
    '/_authed/$workspaceId/_layout/(estimate)/estimates': {
      id: '/_authed/$workspaceId/_layout/(estimate)/estimates'
      path: '/estimates'
      fullPath: '/$workspaceId/estimates'
      preLoaderRoute: typeof AuthedWorkspaceIdLayoutestimateEstimatesRouteImport
      parentRoute: typeof AuthedWorkspaceIdLayoutRoute
    }
    '/_authed/$workspaceId/_layout/(order)/order/$orderId/_layout': {
      id: '/_authed/$workspaceId/_layout/(order)/order/$orderId/_layout'
      path: '/order/$orderId'
      fullPath: '/$workspaceId/order/$orderId'
      preLoaderRoute: typeof AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutRouteImport
      parentRoute: typeof AuthedWorkspaceIdLayoutRoute
    }
    '/_authed/$workspaceId/_layout/(estimate)/estimate/$estimateId/_layout': {
      id: '/_authed/$workspaceId/_layout/(estimate)/estimate/$estimateId/_layout'
      path: '/estimate/$estimateId'
      fullPath: '/$workspaceId/estimate/$estimateId'
      preLoaderRoute: typeof AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutRouteImport
      parentRoute: typeof AuthedWorkspaceIdLayoutRoute
    }
    '/_authed/$workspaceId/_layout/(order)/order/$orderId/_layout/': {
      id: '/_authed/$workspaceId/_layout/(order)/order/$orderId/_layout/'
      path: '/'
      fullPath: '/$workspaceId/order/$orderId/'
      preLoaderRoute: typeof AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutIndexRouteImport
      parentRoute: typeof AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutRoute
    }
    '/_authed/$workspaceId/_layout/(estimate)/estimate/$estimateId/_layout/': {
      id: '/_authed/$workspaceId/_layout/(estimate)/estimate/$estimateId/_layout/'
      path: '/'
      fullPath: '/$workspaceId/estimate/$estimateId/'
      preLoaderRoute: typeof AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutIndexRouteImport
      parentRoute: typeof AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutRoute
    }
    '/_authed/$workspaceId/_layout/(order)/order/$orderId/_layout/chat': {
      id: '/_authed/$workspaceId/_layout/(order)/order/$orderId/_layout/chat'
      path: '/chat'
      fullPath: '/$workspaceId/order/$orderId/chat'
      preLoaderRoute: typeof AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutChatRouteImport
      parentRoute: typeof AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutRoute
    }
    '/_authed/$workspaceId/_layout/(estimate)/estimate/$estimateId/_layout/chat': {
      id: '/_authed/$workspaceId/_layout/(estimate)/estimate/$estimateId/_layout/chat'
      path: '/chat'
      fullPath: '/$workspaceId/estimate/$estimateId/chat'
      preLoaderRoute: typeof AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutChatRouteImport
      parentRoute: typeof AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutRoute
    }
  }
}

interface AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutRouteChildren {
  AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutChatRoute: typeof AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutChatRoute
  AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutIndexRoute: typeof AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutIndexRoute
}

const AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutRouteChildren: AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutRouteChildren =
  {
    AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutChatRoute:
      AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutChatRoute,
    AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutIndexRoute:
      AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutIndexRoute,
  }

const AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutRouteWithChildren =
  AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutRoute._addFileChildren(
    AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutRouteChildren,
  )

interface AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutRouteChildren {
  AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutChatRoute: typeof AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutChatRoute
  AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutIndexRoute: typeof AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutIndexRoute
}

const AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutRouteChildren: AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutRouteChildren =
  {
    AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutChatRoute:
      AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutChatRoute,
    AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutIndexRoute:
      AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutIndexRoute,
  }

const AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutRouteWithChildren =
  AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutRoute._addFileChildren(
    AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutRouteChildren,
  )

interface AuthedWorkspaceIdLayoutRouteChildren {
  AuthedWorkspaceIdLayoutAnalyticsRoute: typeof AuthedWorkspaceIdLayoutAnalyticsRoute
  AuthedWorkspaceIdLayoutBoardRoute: typeof AuthedWorkspaceIdLayoutBoardRoute
  AuthedWorkspaceIdLayoutClientsRoute: typeof AuthedWorkspaceIdLayoutClientsRoute
  AuthedWorkspaceIdLayoutSearchRoute: typeof AuthedWorkspaceIdLayoutSearchRoute
  AuthedWorkspaceIdLayoutSettingsRoute: typeof AuthedWorkspaceIdLayoutSettingsRoute
  AuthedWorkspaceIdLayoutTeamRoute: typeof AuthedWorkspaceIdLayoutTeamRoute
  AuthedWorkspaceIdLayoutestimateEstimatesRoute: typeof AuthedWorkspaceIdLayoutestimateEstimatesRoute
  AuthedWorkspaceIdLayouthomeIndexRoute: typeof AuthedWorkspaceIdLayouthomeIndexRoute
  AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutRoute: typeof AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutRouteWithChildren
  AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutRoute: typeof AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutRouteWithChildren
}

const AuthedWorkspaceIdLayoutRouteChildren: AuthedWorkspaceIdLayoutRouteChildren =
  {
    AuthedWorkspaceIdLayoutAnalyticsRoute:
      AuthedWorkspaceIdLayoutAnalyticsRoute,
    AuthedWorkspaceIdLayoutBoardRoute: AuthedWorkspaceIdLayoutBoardRoute,
    AuthedWorkspaceIdLayoutClientsRoute: AuthedWorkspaceIdLayoutClientsRoute,
    AuthedWorkspaceIdLayoutSearchRoute: AuthedWorkspaceIdLayoutSearchRoute,
    AuthedWorkspaceIdLayoutSettingsRoute: AuthedWorkspaceIdLayoutSettingsRoute,
    AuthedWorkspaceIdLayoutTeamRoute: AuthedWorkspaceIdLayoutTeamRoute,
    AuthedWorkspaceIdLayoutestimateEstimatesRoute:
      AuthedWorkspaceIdLayoutestimateEstimatesRoute,
    AuthedWorkspaceIdLayouthomeIndexRoute:
      AuthedWorkspaceIdLayouthomeIndexRoute,
    AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutRoute:
      AuthedWorkspaceIdLayoutestimateEstimateEstimateIdLayoutRouteWithChildren,
    AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutRoute:
      AuthedWorkspaceIdLayoutorderOrderOrderIdLayoutRouteWithChildren,
  }

const AuthedWorkspaceIdLayoutRouteWithChildren =
  AuthedWorkspaceIdLayoutRoute._addFileChildren(
    AuthedWorkspaceIdLayoutRouteChildren,
  )

interface AuthedRouteChildren {
  AuthedNewRoute: typeof AuthedNewRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedWorkspaceIdLayoutRoute: typeof AuthedWorkspaceIdLayoutRouteWithChildren
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedNewRoute: AuthedNewRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedWorkspaceIdLayoutRoute: AuthedWorkspaceIdLayoutRouteWithChildren,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRoute,
  JoinCodeRoute: JoinCodeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
